import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logout",
  "use": "icon-logout-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-logout\">\n<path d=\"M124.9,46.8l-1.8,4.3c-1.9,4.6-0.2,10,4,12.6c15.4,9.7,25.2,27.3,23.8,47.1c-1.9,25.4-21.7,45.2-47.1,47.1\n\tc-29.9,2.2-54.9-21.5-54.9-50.9c0-18.2,9.5-34.2,23.8-43.2c4.3-2.7,6-8,4.1-12.7l-1.8-4.3c-2.4-5.9-9.5-8.2-14.9-4.8\n\tc-22.5,13.8-37.3,38.9-36.4,67.4c1.2,40.2,34.1,72.9,74.4,73.8c43,1,78.1-33.5,78.1-76.2c0-27.5-14.6-51.6-36.4-65\n\tC134.5,38.6,127.4,40.9,124.9,46.8z\" />\n<path d=\"M102.4,88.2h-4.8c-5.7,0-10.3-4.6-10.3-10.3V27.1c0-5.7,4.6-10.3,10.3-10.3h4.8c5.7,0,10.3,4.6,10.3,10.3v50.9\n\tC112.7,83.6,108.1,88.2,102.4,88.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/logout.svg
// module id = KvOj
// module chunks = 3